import React from 'react';

const Contact = (props) => {
    return (
        <div id="contact" className="main-container">
			<section className="map-overlay">
				<div className="map-holder">
					<iframe property="" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d117763.55157483256!2d75.7938095!3d22.7241158!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fcad1b410ddb%3A0x96ec4da356240f4!2sIndore%2C%20Madhya%20Pradesh!5e0!3m2!1sen!2sin!4v1592925160990!5m2!1sen!2sin"></iframe>
				</div>				
				<div className="container">
					<div className="row">
						<div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 text-center">
							<div className="details-holder" style={{height: '350px'}}>
								<div className="align-vertical" style={{paddingTop: '88px'}}>
									<img alt="" src="img/logo.png" />
									<p className="lead">programmerwebapps@gmail.com<br/>+91 9644289111</p>
									<p>Indore, India</p>
									<p>Skype: imanishthakur</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
    )
}

export default Contact;